import React from "react";
import { useLang } from "../../context/LangContext";
import { Reveal } from "./Reveal";

export const TrustStrip = () => {
  const { t } = useLang();
  const items = [
    { big: "2008", label: t.trust.since, desc: t.trust.since },
    { big: "ISO", label: t.trust.iso, desc: t.trust.isoDesc },
    { big: "NACE", label: t.trust.nace, desc: t.trust.naceDesc },
    { big: "IT · EU", label: t.trust.coverage, desc: t.trust.coverageDesc },
  ];
  return (
    <section id="trust" className="relative bg-brand-steel border-y border-white/10" data-testid="trust-strip">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/10">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.08} className="py-10 lg:py-12 px-4 lg:px-8 text-center lg:text-left">
              <div className="font-display text-3xl lg:text-4xl font-semibold text-brand-azure">{it.big === "2008" ? it.big : it.big}</div>
              <div className="mt-2 font-condensed uppercase tracking-[0.15em] text-xs text-slate-400">{it.desc}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
